import React from 'react';

import { useFormikContext } from 'formik';

import { camelToSpaceCase } from 'lib/helpers/utility';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

const options = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Custom',
    value: 'custom'
  }
];

const ExportColumnsCheckbox = () => {
  const { values, setFieldValue, columns } = useFormikContext();

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Export Columns
        <span className="text-danger-400">*</span>
      </label>

      <div className="mt-2">
        <SegmentedControl
          active={values?.export_columns?.[0]}
          className="!w-auto"
          onClick={(item) => setFieldValue('export_columns', [item.value])}
          items={options}
        />
      </div>

      {values?.export_columns?.includes('custom') && (
        <div className="mt-4 grid grid-cols-2 gap-4">
          {columns?.map((option, idx) => {
            const value = option?.field;
            const isChecked = values?.selected_columns?.includes(value);

            return (
              <Checkbox
                key={idx}
                data-qa={`checkbox-${value}`}
                isChecked={isChecked}
                handleClick={() => {
                  const newValues = values?.selected_columns?.includes(value)
                    ? values?.selected_columns?.filter((val) => val !== value)
                    : [...(values?.selected_columns || []), value];

                  setFieldValue('selected_columns', newValues);
                }}
                label={option?.headerName || camelToSpaceCase(value)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExportColumnsCheckbox;
